module.exports = __webpack_public_path__ + "img/que_ofrecemos_qualitycare.38f24c29.png";